module.exports = __webpack_public_path__ + "img/NewCapeReturn.82c0a655.png";